<script setup lang="ts">

import { useGameStore } from '@/stores/gameStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { version } from '@/../package.json'
import { watch, ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()
const appVersion = version
const showLoadingText = ref(false)
let loadingTextTimer: number | null = null

const reloadGame = () => {
  window.location.reload()
}

// Close all modals when game goes out of sync
watch(() => gameStore.gameOutOfSync, (isOutOfSync) => {
  if (isOutOfSync) {
    gameStore.modalType = ''
    gameStore.modal2Type = ''
    gameStore.infoModalType = ''
  }
})

// Only show loading text after 5 seconds
onMounted(() => {
  loadingTextTimer = window.setTimeout(() => {
    showLoadingText.value = true
  }, 5000)
})

onUnmounted(() => {
  if (loadingTextTimer !== null) {
    window.clearTimeout(loadingTextTimer)
  }
})

</script>

<template>
  <div v-if="!gameStore.websocketInitialSyncCompleted" class="fixed inset-0 flex items-center justify-center bg-black z-50 text-white">
    <div class="flex flex-col items-center">
      <img alt="Logo" :src="gameStore.cdnUrl + 'images/logos/splash.webp'" class="p-5" fetchpriority="high" decoding="async">
      <div class="text-xs opacity-50 mb-4">v{{ appVersion }}</div>
      <div class="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"></div>
      <div v-if="showLoadingText" class="pt-2">{{ gameStore.loadingText }}</div>
    </div>
  </div>
  <div v-else-if="gameStore.backendError">
    <div class="fixed inset-0 flex items-center justify-center bg-black z-50 text-white">
      <div class="flex flex-col items-center">
        <div class="text-2xl">{{ t('common.errors.backendError') }}</div>
        <div class="pt-2 pb-2">{{ t('common.errors.pleaseReport') }}</div>
        <div class="text-red-500">
          {{ gameStore.backendError }}
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="gameStore.gameOutOfSync">
    <div class="fixed inset-0 flex items-center justify-center bg-black z-50 text-white">
      <div class="flex flex-col items-center text-center">
        <img alt="Logo" :src="gameStore.cdnUrl + 'images/logos/splash.webp'" class="p-5" fetchpriority="high" decoding="async">
        <div class="text-xs opacity-50 mb-4">v{{ appVersion }}</div>
        <div class="text-2xl pb-4">{{ t('common.errors.gameDisconnected') }}</div>
        <ActionButton @click="reloadGame()" :end-margin="false">{{ t('common.actions.reconnect') }}</ActionButton>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>
